import SettingsIcon from '@mui/icons-material/Settings';
import { IconButton, Stack, Typography, useTheme } from '@mui/material';

import headerImageUrl from '@images/header-background.png';
import { useAdminRole } from '@hooks/useAdminRole';
import { useAdminPanelStore } from '@store/adminPanelStore';

import { headerTexts } from '../constants';

const Header = () => {
    const theme = useTheme();
    const toggleAdminPanelVisibility = useAdminPanelStore((state) => state.toggle);

    const { isGlobalAdmin, isLocalAdmin } = useAdminRole();

    const isAdmin = isGlobalAdmin || isLocalAdmin;

    return (
        <Stack
            component='header'
            direction='row'
            justifyContent='space-between'
            alignItems='center'
            sx={{
                backgroundColor: '#FFFFFFCC',
                backgroundImage: `url(${headerImageUrl})`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: '100%',
                backgroundBlendMode: 'overlay',
                borderTopLeftRadius: `${theme.borderRadius.small}`,
                borderTopRightRadius: `${theme.borderRadius.small}`,
                padding: 1,
            }}
        >
            <Stack gap={1}>
                <Typography variant='h1'>{headerTexts.title}</Typography>
                <Typography
                    variant='h2'
                    color={theme.palette.customColors.purple}
                    fontSize='1rem'
                    fontWeight={400}
                >
                    {headerTexts.subtitle}
                </Typography>
            </Stack>
            <IconButton onClick={toggleAdminPanelVisibility} disabled={!isAdmin}>
                <SettingsIcon />
            </IconButton>
        </Stack>
    );
};

export default Header;
